import React from 'react'
import { DashboardCard } from './OutstandingBalance'
import { useTheme } from '../../../middleware/ThemeContext';
import CardIconHeader from './Components/CardIconHeader';
import StyledText from '../../../components/StyledComponents/StyledText';
import ClockIcon from '../../../assets/icons/ClockIcon';

const PendingRenewals = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader 
            icon={<ClockIcon color={theme.CorporateTheme.colors.blueberry} /> }
            title='Pending Renewals'
            count="156"
            iconBgColor='rgba(5, 86, 203, 0.1)'
        />
        <hr />
        {/* <StyledText
            fontSize='14px'
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.blueberry}
            fontStyle='italic'
            style={{ textAlign: 'right' }}
        >
            +12% from last month
        </StyledText> */}
    </DashboardCard>
  )
}

export default PendingRenewals